<div class="govuk-grid-row">
    <div class="govuk-grid-column-full">
        <div class="govuk-panel govuk-panel--confirmation govuk-panel--confirmation--inverse">
            <h1 class="govuk-panel__title">
                {{this.selectedDepartment?.extra?.confirmation_page_title}}
            </h1>
            <div class="govuk-panel__body" aria-label="Booking reference">
                {{ 'CONFIRMATION.REFERENCE_TEXT' | translate: bookingsPlaceholder }}
            </div>
        </div>
        <p class="govuk-body" *ngIf="selectedService && !hideCongratsMessageForService.includes(selectedService?._data?.id)">Congratulations on making your ceremony booking!... We will be sending you a confirmation email with details on how to access your personalised ceremony portal.</p>
        <h2 class="govuk-heading-l">Booking Details:</h2>

        <div class="govuk-summary-card">
            <div class="govuk-summary-card__title-wrapper">
                <h2 class="govuk-summary-card__title">
                    {{ 'COMMON.BOOKING' | translate}}
                </h2>
            </div>


            <div class="govuk-summary-card__content">
                <dl class="govuk-summary-list">
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key">
                            {{'COMMON.SERVICE' | translate}}
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{selectedService?.name}}
                        </dd>
                    </div>
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key">
                            Venue
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{selectedResourceObj?.name}}
                        </dd>
                    </div>
                </dl>
            </div>
        </div>



        <div class="govuk-summary-card">
            <div class="govuk-summary-card__title-wrapper">
                <h2 class="govuk-summary-card__title">
                    {{'COMMON.DATE_TIME' | translate}}
                </h2>
            </div>
            <div class="govuk-summary-card__content">
                <dl class="govuk-summary-list">
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key">
                            {{'COMMON.DATE' | translate}}
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{selectedSlot?.start | date: 'EEEE d MMMM yyyy' : '' : translateService.currentLang}}
                        </dd>
                    </div>

                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key">
                            {{'COMMON.TIME' | translate}}
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{selectedSlot?.displayTime}}
                        </dd>
                    </div>
                </dl>
            </div> 
        </div>

        <div class="govuk-summary-card">
            <div class="govuk-summary-card__title-wrapper">
                <h2 class="govuk-summary-card__title">
                    {{ 'COMMON.PATIENT_DETAILS' | translate }}
                </h2>
            </div>
            <div class="govuk-summary-card__content">
                <dl class="govuk-summary-list">
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key">
                            {{'COMMON.NAME' | translate}}
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{client?.first_name}} {{client?.last_name}}
                        </dd>
                    </div>

                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key">
                            {{'COMMON.EMAIL_ADDRESS' | translate}}
                        </dt>
                        <dd class="govuk-summary-list__value"> 
                            {{datastoreService?.booking?.email}}
                        </dd>
                    </div>

                    <div class="govuk-summary-list__row" *ngIf="client?.mobile_number">
                        <dt class="govuk-summary-list__key">
                            {{'COMMON.MOBILE_NUMBER' | translate}}
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{selectedSlot?.mobile_number}}
                        </dd>
                    </div>

                    <div class="govuk-summary-list__row" *ngIf="client?.postcode">
                        <dt class="govuk-summary-list__key">
                            {{'COMMON.POSTNAME' | translate}}
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{selectedSlot?.postcode}}
                        </dd>
                    </div>

                </dl>
            </div>
        </div>


        <!-- <div class="govuk-summary-card">
            <div class="govuk-summary-card__title-wrapper">
                <h2 class="govuk-summary-card__title">
                    {{'COMMON.BOOKING_DETAILS' | translate}}
                </h2>
            </div>
            <div class="govuk-summary-card__content">
                <dl class="govuk-summary-list" *ngFor="let detail of bookingSummaryData">
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key">
                            {{ detail.name | translateSplit }}
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{ detail.answer }}
                        </dd>
                    </div>
                </dl>
            </div>
        </div> -->

    </div>
</div>

<div class="govuk-button-group">
    <button type="submit" class="govuk-button govuk-button--secondary" data-module="govuk-button" (click)="print()">{{
        'COMMON.PRINT'| translate}}
    </button>
    <button *ngIf="!adminMode" type="submit" class="govuk-button" data-module="govuk-button"
        (click)="goToLogin()">{{'COMMON.LOGIN_TO_CEREMONY' |
        translate}}
    </button>
</div> 